import { z } from 'zod';

import {
  TicketDetailIncidentPhotoSchema,
  TicketDetailPhotoSchema,
} from './ticket-detail-schemas.js';

// ticket-photos-for-valet — least-privilege contract for GET
// /valet/tickets/:id/photos. The valet (operator role) needs to VALIDATE the
// vehicle's condition at delivery time (client request), not the full
// billing/audit aggregate the admin ticket-detail route exposes. This
// schema intentionally reuses TicketDetailPhotoSchema /
// TicketDetailIncidentPhotoSchema (same signed-GET shape, D8) but composes
// them into a narrower object — photos + incidentPhotos ONLY.

export const ValetTicketPhotosResponseSchema = z.object({
  photos: z.array(TicketDetailPhotoSchema),
  incidentPhotos: z.array(TicketDetailIncidentPhotoSchema),
});
export type ValetTicketPhotosResponse = z.infer<typeof ValetTicketPhotosResponseSchema>;
